import React, {useState, useEffect} from 'react'
import style from "./style/MyWork.module.css"
import Swiper from '../UI/Swiper'
import worksData from "../data/worksData"
import { useInView } from 'react-intersection-observer'

const works = worksData

function MyWorks() {

    const [ref, inView] = useInView()
    const [titleWorks, inViewTitleWorks] = useInView()
    const [titleSkils, inViewTitleSkils] = useInView()

    const [percentageKnowledgeHtml, setPercentageKnowledgeHtml] = useState(1);
    const [percentageKnowledgeCss, setPercentageKnowledgeCss] = useState(1);
    const [percentageKnowledgeJs, setPercentageKnowledgeJs] = useState(1);
    const [percentageKnowledgeReact, setPercentageKnowledgeReact] = useState(1);
    const [styleTetileWorks, setStyleTitleWorks] = useState(style.works__h2)
    const [styleTetileSkils, setStyleTetileSkils] = useState(style.skills__h2)



    useEffect(() => {
      
        if (inView) {
          const intervalHTML = setInterval(() => {
            if (percentageKnowledgeHtml < 70) {
              setPercentageKnowledgeHtml(percentageKnowledgeHtml + 1);
            }
          }, 20);
    
          const intervalCSS = setInterval(() => {
            if (percentageKnowledgeCss < 65) {
              setPercentageKnowledgeCss(percentageKnowledgeCss + 1);
            }
          }, 20);
    
    
          const intervalJs = setInterval(() => {
            if (percentageKnowledgeJs < 60) {
              setPercentageKnowledgeJs(percentageKnowledgeJs + 1);
            }
          }, 20);
    
          const intervalReact = setInterval(() => {
            if (percentageKnowledgeReact < 40) {
              setPercentageKnowledgeReact(percentageKnowledgeReact + 1);
            }
          }, 20);
    
          return () => {
            clearInterval(intervalHTML);
            clearInterval(intervalCSS);
            clearInterval(intervalJs);
            clearInterval(intervalReact);
          };
        } else {
          setPercentageKnowledgeHtml(0);
          setPercentageKnowledgeCss(0);
          setPercentageKnowledgeJs(0);
          setPercentageKnowledgeReact(0);
        }
      }, [inView, percentageKnowledgeHtml, percentageKnowledgeCss, percentageKnowledgeJs, percentageKnowledgeReact]);

      useEffect(()=>{
        if(inViewTitleWorks){
          setStyleTitleWorks(style.works__h2Active)
        }else{
          setStyleTitleWorks(style.works__h2)
        }

        if (inViewTitleSkils) {
          setStyleTetileSkils(style.skills__h2Active)
        }else{
          setStyleTetileSkils(style.skills__h2)
        }

      })
      
    return (
        <div className={style.works__container}>
            <h2 ref={titleWorks} className={styleTetileWorks}>My Works</h2>
            <div className={style.swiper__container}>
                {works.map((val, index)=>(
                    <div key={index}>
                        <Swiper works={val.images} link={val.url}/>
                    </div>
                ))}
            </div>
            <div className={style.skills}>
                <h2 ref={titleSkils} className={styleTetileSkils}>My Skills</h2>
                <div className={style.skills__wrapper}>
                    <ul ref={ref} className={style.skills__list}>
                        <li>
                            <p className={style.skills__mark}>{percentageKnowledgeHtml}%</p>
                            <p className={style.skills__name}>HTML</p>
                        </li>
                        <li>
                            <p className={style.skills__mark}>{percentageKnowledgeCss}%</p>
                            <p className={style.skills__name}>CSS</p>
                        </li>
                        <li>
                            <p className={style.skills__mark}>{percentageKnowledgeJs}%</p>
                            <p className={style.skills__name}>JAVASCRIPT</p>
                        </li>
                        <li>
                            <p className={style.skills__mark}>{percentageKnowledgeReact}%</p>
                            <p className={style.skills__name}>REACT.JS</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default MyWorks